export class ConflictError extends Error {
  code = 409;

  constructor() {
    super();
  }
}
